import { useEffect } from "react";
export function useShadowDomWheelScrollFix() {
    useEffect(() => {
        const shadowHost = document.getElementById("root-atarim");
        const shadowRoot = shadowHost?.shadowRoot;
        if (!shadowRoot) return;
        const forwardWheelEvent = (e: WheelEvent) => {
            const path = e.composedPath() as HTMLElement[];
            // Find the first scrollable element with data-dialog-scroll in the event path
            const scrollable = path.find(el =>
                el instanceof HTMLElement && el.hasAttribute("data-dialog-scroll")
            ) as HTMLElement | undefined;
            if (scrollable) {
                scrollable.scrollTop += e.deltaY;
                e.preventDefault();
            }
        };
        shadowRoot.addEventListener("wheel", forwardWheelEvent, { passive: false });
        return () => {
            shadowRoot.removeEventListener("wheel", forwardWheelEvent);
        };
    }, []);
}